<script>
  import { createEventDispatcher, onMount, tick } from 'svelte'
  import { opsInFlight } from '../stores.js'
  import { opsConfirmHint } from '../api.js'

  export let open = false
  export let action = 'restart'
  export let unit = 'pmbot-paper'
  /** Dialog TTL seconds — blocks auto-close while opsInFlight. */
  export let ttlSec = 60

  const dispatch = createEventDispatcher()

  let dialog
  let inputEl
  let typed = ''
  let localError = ''
  let remaining = ttlSec
  /** @type {ReturnType<typeof setInterval> | null} */
  let timer = null

  $: hint = opsConfirmHint(action, unit)
  $: actionRu =
    action === 'start' ? 'старт' : action === 'stop' ? 'стоп' : action === 'restart' ? 'перезапуск' : action

  function clearTimer() {
    if (timer != null) {
      clearInterval(timer)
      timer = null
    }
  }

  function startTimer() {
    clearTimer()
    remaining = ttlSec
    timer = setInterval(() => {
      if ($opsInFlight) return
      remaining -= 1
      if (remaining <= 0) {
        clearTimer()
        if (dialog && dialog.open) dialog.close()
        open = false
        dispatch('expire')
      }
    }, 1000)
  }

  $: if (open && dialog) {
    typed = ''
    localError = ''
    startTimer()
    tick().then(() => {
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal()
      inputEl && inputEl.focus()
    })
  }

  function blockClose(e) {
    if ($opsInFlight) e.preventDefault()
  }

  function onCancelClick() {
    if ($opsInFlight) return
    clearTimer()
    open = false
    if (dialog && dialog.open) dialog.close()
    dispatch('cancel')
  }

  function onSubmit(e) {
    e.preventDefault()
    if ($opsInFlight) return
    const confirm = typed.trim()
    if (!confirm) {
      localError = 'Введите токен подтверждения'
      return
    }
    // Pass user-typed confirm only — never auto-fill from hint
    dispatch('confirm', { action, confirm, unit })
  }

  onMount(() => {
    if (!dialog) return
    dialog.addEventListener('cancel', blockClose)
    return () => {
      dialog.removeEventListener('cancel', blockClose)
      clearTimer()
    }
  })

  export function close() {
    if ($opsInFlight) return
    clearTimer()
    open = false
    if (dialog && dialog.open) dialog.close()
  }

  function fmtTimer(s) {
    const m = Math.floor(s / 60)
    const r = s % 60
    return `${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`
  }
</script>

<dialog class="pm-dialog" bind:this={dialog} aria-labelledby="ops-confirm-title">
  <form class="pm-dialog__form" on:submit={onSubmit}>
    <h3 class="pm-dialog__title" id="ops-confirm-title">Подтвердите действие</h3>
    <p class="pm-dialog__body">
      Вы собираетесь выполнить «{actionRu}» для {unit}. Это меняет systemd на сервере. Подтвердите токеном
      ниже — введите его вручную.
    </p>
    <label class="pm-dialog__label" for="ops-confirm-input">
      Токен:
      <code>{hint}</code>
    </label>
    <input
      id="ops-confirm-input"
      class="pm-dialog__input"
      bind:this={inputEl}
      bind:value={typed}
      autocomplete="off"
      spellcheck="false"
      disabled={$opsInFlight}
      required
    />
    <p class="pm-meta">
      {#if $opsInFlight}
        Выполняется… таймер на паузе
      {:else}
        Таймер: {fmtTimer(remaining)}
      {/if}
    </p>
    {#if localError}
      <p class="pm-ops-msg pm-ops-msg--bad">{localError}</p>
    {/if}
    <div class="pm-dialog__actions">
      <button type="button" class="pm-btn pm-btn--ghost" disabled={$opsInFlight} on:click={onCancelClick}>
        Отмена
      </button>
      <button type="submit" class="pm-btn pm-btn--accent" disabled={$opsInFlight}>
        {$opsInFlight ? 'Выполняется…' : 'Выполнить'}
      </button>
    </div>
  </form>
</dialog>
